import gmx_zMixins         from '../../../../../../includes/Jmixins/zMixins'

// Locally declared common Data-Props & SVG Drawing Support
import lmx_LocalValues          from './set_LocalValues'
import lmx_Watching             from './Watching'
import lmx_Events               from './Events'

import lmx_Elements from './Elements.mixin'          // Common functions for Drawing the Charts & Tables
import lmx_Header from './Draw_Header.mixin'
import lmx_Taps from './Draw_Taps.mixin'

export default {
  mixins: [
    gmx_zMixins, 

    // Local Mixins
    lmx_LocalValues,
    lmx_Watching,
    lmx_Events,
    
    // Charting Mixins
    lmx_Elements,
    lmx_Header,
    lmx_Taps,

  ],
}
